import { Component, Inject, Injector, OnDestroy, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { filter, Subject, switchMap, takeUntil } from 'rxjs'

import { SocketService } from '@app/modules/client/map/shared/socket.service'
import { DeviceSensorsService } from '@shared/services/device-sensors.service'
import { MapApiService } from '@app/modules/client/map/map-api.service'
import { MapVehiclesService } from '@app/modules/client/map/map-details/vehicles/map-vehicles.service'
import { SocketAssetsService } from '@app/modules/client/map/shared/socketAssets.service'
import { MapService } from '@app/modules/client/map/map.service'
import { DestroyService } from '@core/services/destroy.service'
import { MapRealtimeGateway } from '@core/services/realtime/map-realtime.gateway'
import { GoMapSocketAdapter } from '@core/services/realtime/go-map-socket.adapter'
import { AssetRealtimeGateway } from '@core/services/realtime/asset-realtime.gateway'
import { GoAssetSocketAdapter } from '@core/services/realtime/go-asset-socket.adapter'
import { FeatureFlagService } from '@core/services/feature-flag.service'

import { TrackerHistoryPayload } from '@app/modules/client/map/shared/models/tracker-history-payload.model'

@Component({
  templateUrl: './check-device-status-dialog.component.html',
  styleUrls: ['./check-device-status-dialog.component.scss'],
  providers: [
    SocketService,
    GoMapSocketAdapter,
    {
      provide: MapRealtimeGateway,
      useFactory: (flags: FeatureFlagService, injector: Injector) =>
        flags.realtimeV3 ? injector.get(GoMapSocketAdapter) : injector.get(SocketService),
      deps: [FeatureFlagService, Injector],
    },
    MapService,
    DeviceSensorsService,
    SocketAssetsService,
    GoAssetSocketAdapter,
    {
      provide: AssetRealtimeGateway,
      useFactory: (flags: FeatureFlagService, injector: Injector) =>
        flags.realtimeV3 ? injector.get(GoAssetSocketAdapter) : injector.get(SocketAssetsService),
      deps: [FeatureFlagService, Injector],
    },
    MapVehiclesService,
    MapApiService,
    DestroyService,
  ],
  standalone: false,
})
export class CheckDeviceStatusDialogComponent implements OnInit, OnDestroy {
  trackerData: TrackerHistoryPayload

  isInteger = Number.isInteger

  isNumber = Number.isFinite

  private readonly onDestroy$ = new Subject<void>()

  constructor(
    private socketService: MapRealtimeGateway,
    private featureFlagService: FeatureFlagService,
    @Inject(MAT_DIALOG_DATA) private vehicleId: number,
  ) {}

  get isRealtimeV3(): boolean {
    return this.featureFlagService.realtimeV3
  }

  ngOnInit(): void {
    this.socketService.subscribe([this.vehicleId])

    this.socketService.socketState$
      .pipe(
        filter((s) => this.socketService.isConnected(s)),
        switchMap(() => this.socketService.getCoordinates()),
        takeUntil(this.onDestroy$),
      )
      .subscribe((trackerPayload: TrackerHistoryPayload) => (this.trackerData = trackerPayload))
  }

  ngOnDestroy(): void {
    this.onDestroy$.next()
    this.onDestroy$.complete()
  }
}
